import { Component, EventEmitter, OnChanges, OnInit, Output, input, model, output } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog'
import { Router } from '@angular/router';
import { faWarning } from '@fortawesome/free-solid-svg-icons';
import { faCircleXmark } from '@fortawesome/free-regular-svg-icons';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { ReportService } from 'src/app/services/report.service';
import { Editor, Toolbar } from 'ngx-editor';
import { Subject } from 'rxjs';
import { ConfirmationToastComponent } from 'src/app/components/confirmation-toast/confirmation-toast.component';
import { APP_CONSTANTS } from 'src/app/shared/app.constants';
import { AutoSaveComponent } from '../auto-save/auto-save.component';

@Component({
    selector: 'app-analysis-summary',
    templateUrl: './analysis-summary.component.html',
    styleUrls: ['./analysis-summary.component.scss'],
    standalone: false
})


export class AnalysisSummaryComponent extends AutoSaveComponent implements OnChanges, OnInit {

  faWarning = faWarning;
  faCircleXmark = faCircleXmark as IconProp;

  editor1!: Editor;
  editor2!: Editor;
  editor3!: Editor;
  editor4!: Editor;
  editor5!: Editor;
  editor6!: Editor;
  editor7!: Editor;
  toolbar: Toolbar = APP_CONSTANTS.EDITOR_TOOLBAR;

  report = input.required<any>();
  nav = model.required<string>();
  status = output<number | undefined>();
    @Output() loaded = new EventEmitter();
  errorList: string[] = [];
  forests = []
  saveSubject = new Subject<any>();
  optional = input(false);
  simple = input(false);
  page = input("4");

  reg = APP_CONSTANTS.URL_REGEX;

  form = this.formBuilder.group({
    background: ["", Validators.maxLength(6000)],
    threats_human: ["", Validators.maxLength(6000)],
    threatsproperty: ["", Validators.maxLength(6000)],
    threats_natural: ["", Validators.maxLength(6000)],
    threats_cultural: ["", Validators.maxLength(6000)],
    treat_prob_land: [0],
    treat_prob_channel: [0],
    treat_prob_trails: [0],
    treat_prob_safety: [0],
    critical_values: ["", [Validators.pattern(this.reg), Validators.maxLength(500)]],
    cost_no_action: ["", Validators.maxLength(6000)],
    cost_alternative: ["", Validators.maxLength(6000)],
  });


  constructor(
    public dialog: MatDialog,
    private readonly router: Router,
    private readonly formBuilder: FormBuilder,
    public readonly reportService: ReportService,
    public readonly toast: ConfirmationToastComponent,
  ) {
    super()
  }

  ngOnInit(): void {
    this.status.emit(undefined);
    this.editor1 = new Editor();
    this.editor2 = new Editor();
    this.editor3 = new Editor();
    this.editor4 = new Editor();
    this.editor5 = new Editor();
    this.editor6 = new Editor();
    this.editor7 = new Editor();

    this.form.patchValue({
      background: this.customATOB(this.report().background ?? ""),
      threats_human: this.customATOB(this.report().threats_human ?? ""),
      threatsproperty: this.customATOB(this.report().threatsproperty ?? ""),
      threats_natural: this.customATOB(this.report().threats_natural ?? ""),
      threats_cultural: this.customATOB(this.report().threats_cultural ?? ""),
      treat_prob_land: this.report().treat_prob_land ?? 0 as number | null,
      treat_prob_channel: this.report().treat_prob_channel ?? 0 as number | null,
      treat_prob_trails: this.report().treat_prob_trails ?? 0 as number | null,
      treat_prob_safety: this.report().treat_prob_safety ?? 0 as number | null,
      critical_values: decodeURI(this.report().critical_values ?? ""),
      cost_no_action: this.customATOB(this.report().cost_no_action ?? ""),
      cost_alternative: this.customATOB(this.report().cost_alternative ?? ""),
    })
    this.listenForChanges(this.form);
    this.formReady = true;
    this.loaded.emit(true);
  }

  ngOnChanges(): void {
    if (this.nav() != '') this.navigate();
  }

  onChangeEditor(html: any, field: any) {
    if (html == '<p></p>') {
      let patch = '{"' + field + '": ""}'
      this.form.patchValue(JSON.parse(patch))
    }
  }

  navigate() {
    this.save(true);
  }

  route() {
    this.save()
    switch (this.nav()) {
      case 'forward': {
        this.router.navigate(['/2500-8-report'], { queryParams: { report_id: this.report().report_id, report_page_input: +this.page()+1 } });
        break;
      }
      case 'back': {
        this.router.navigate(['/2500-8-report'], { queryParams: { report_id: this.report().report_id, report_page_input: +this.page()-1 } });
        break;
      }
      case 'close': {
        this.router.navigate(['fire-overview'], { queryParams: { assessment_id: this.report().assessment_id } });
        break;
      }
      default: {
        if (Number(this.nav()))
          this.router.navigate(['/2500-8-report'], { queryParams: { report_id: this.report().report_id, report_page_input: this.nav() } });
        break;
      }
    }
  }

  convertBlankFields() {
    // Convert blank number fields to null
    let numbers = ["treat_prob_land", "treat_prob_channel", "treat_prob_trails", "treat_prob_safety"]
    for (let field of numbers) {
      if (this.form.get(field)?.value === "") {
        this.form.patchValue({ [field]: null })
      } else if (this.form.get(field)?.value != null) {
        this.form.patchValue({ [field]: +this.form.get(field)?.value })
      }
    }
  }


  gatherData(): any {
    this.convertBlankFields()

    let data: any = {
      background: this.form.controls.background.valid ? this.customBTOA(this.form.value.background as string) : null,
      threats_human: this.form.controls.threats_human.valid ? this.customBTOA(this.form.value.threats_human as string) : null,
      threatsproperty: this.form.controls.threatsproperty.valid ? this.customBTOA(this.form.value.threatsproperty as string) : null,
      threats_natural: this.form.controls.threats_natural.valid ? this.customBTOA(this.form.value.threats_natural as string) : null,
      threats_cultural: this.form.controls.threats_cultural.valid ? this.customBTOA(this.form.value.threats_cultural as string) : null,
      treat_prob_land: this.form.value.treat_prob_land,
      treat_prob_channel: this.form.value.treat_prob_channel as number | null,
      treat_prob_trails: this.form.value.treat_prob_trails as number | null,
      treat_prob_safety: this.form.value.treat_prob_safety as number | null,
      critical_values: this.form.controls.critical_values.valid ? encodeURI(this.form.value.critical_values as string) : null,
      cost_no_action: this.form.controls.cost_no_action.valid ? this.customBTOA(this.form.value.cost_no_action as string) : null,
      cost_alternative: this.form.controls.cost_alternative.valid ? this.customBTOA(this.form.value.cost_alternative as string) : null,
    }

    let allFieldsFilled = true

    for (let field in this.form.controls) {
      if (this.form.get(field)?.value === null || this.form.get(field)?.value === "") {
        allFieldsFilled = false
      }
    }

    if (this.simple()) allFieldsFilled = data.background !== "" && data.background !== null
    if (this.optional()) allFieldsFilled = true

    data.allFieldsFilled = allFieldsFilled;

    return data
  }

  override save(navigate?: boolean) {
    this.navDebounceCheck(navigate)

    if (!this.form.dirty) {
      if (navigate) {
        this.route()
      }
      // Don't save if nothing has changed on autosave
      return
    }

    let data = this.gatherData()

    if (!navigate && this.checkIfNotNeedToSave(data)) return

    this.saveSubject.next(null)
    this.status.emit(data.allFieldsFilled ? 2 : 1);

    this.reportService.updateReport({
      report_id: this.report().report_id,
      background: data.background,
      threats_human: data.threats_human,
      threatsproperty: data.threatsproperty,
      threats_natural: data.threats_natural,
      threats_cultural: data.threats_cultural,
      treat_prob_land: data.treat_prob_land,
      treat_prob_channel: data.treat_prob_channel,
      treat_prob_trails: data.treat_prob_trails,
      treat_prob_safety: data.treat_prob_safety,
      critical_values: data.critical_values,
      cost_no_action: data.cost_no_action,
      cost_alternative: data.cost_alternative,
      [`page_${this.page()}_status_id`]: data.allFieldsFilled ? 2 : 1,
    }).subscribe({
      next: (response) => {
        if (navigate) {
          if (this.nav() == "forward" && !data.allFieldsFilled) {
            this.form.markAllAsTouched();
            this.errorList = [];
            for (let field in this.form.controls) {
              const control = this.form.get(field);
              if (control?.invalid) {
                this.errorList.push(field.replaceAll('_', ' '));
              }
            }
            window.scrollTo({ top: 0, behavior: 'smooth' });
            this.nav.set('');
            this.postSave();
          } else
            this.route() // navigate route after save because next page needs to see this page's changes
        } else {
          this.postSave();
        }
      },
      error: (response) => {
        this.toast.openErrorSnackBar(`There was an error saving the report`, "Please try again.");
      },
      complete: () => {
        this.form.markAsPristine();
        if (navigate) this.navDebounce = false
      }
    })
  }

  save_close() {
    this.save();
    this.router.navigate(['fire-overview'], { queryParams: { assessment_id: this.report().assessment_id } });
  }

  customATOB(s: string): string {
    try {
      return atob(s)
    } catch (err) {
      if (err) {
        return s
      }
    }
    return s
  }

  customBTOA(s: string): string {
    return btoa(s.replace(/[\u00A0-\u2666]/g, function (c) {
      return '&#' + c.charCodeAt(0) + ';';
    }));
  }
}
